// ===============================
// EVENT CATEGORIES & SERVICES
// ===============================

export const eventCategories = [
  {
    id: "birthday",
    name: "Birthday",
    services: [
      { id: "venue", name: "Venue" },
      { id: "home", name: "Home" },
      { id: "decoration", name: "Decoration" },
      { id: "catering", name: "Catering" },
      { id: "cake", name: "Cake" },
      { id: "dj", name: "DJ" },
      { id: "anchor", name: "Anchor" },
      { id: "photography", name: "Photography" },
      { id: "tent-lighting", name: "Tent & Lighting" },
      { id: "entertainment", name: "Entertainment" },
      { id: "return-gifts", name: "Return Gifts" },
    ],
  },
  {
    id: "anniversary",
    name: "Anniversary",
    services: [
      { id: "venue", name: "Venue" },
      { id: "home", name: "Home" },
      { id: "decoration", name: "Decoration" },
      { id: "catering", name: "Catering" },
      { id: "cake", name: "Cake" },
      { id: "dj", name: "DJ" },
      { id: "photography", name: "Photography" },
      { id: "tent-lighting", name: "Tent & Lighting" },
      { id: "candle-light-dinner", name: "Candle Light Dinner" },
      { id: "gift-arrangement", name: "Gift Arrangement" },
    ],
  },
  {
    id: "wedding",
    name: "Wedding",
    services: [
      { id: "venue", name: "Venue" },
      { id: "decoration", name: "Decoration" },
      { id: "catering", name: "Catering" },
      { id: "dj", name: "DJ" },
      { id: "anchor", name: "Anchor" },
      { id: "tent-lighting", name: "Tent & Lighting" },
      { id: "photography", name: "Photography" },
      { id: "videography", name: "Videography" },
      { id: "makeup", name: "Makeup Artist" },
      { id: "mehndi", name: "Mehndi" },
      { id: "bridal-entry", name: "Bridal Entry" },
      { id: "groom-entry", name: "Groom Entry" },
      { id: "entertainment", name: "Entertainment" },
      { id: "wedding-planner", name: "Wedding Planner" },
    ],
  },
  {
    id: "engagement",
    name: "Engagement",
    services: [
      { id: "venue", name: "Venue" },
      { id: "decoration", name: "Decoration" },
      { id: "catering", name: "Catering" },
      { id: "dj", name: "DJ" },
      { id: "anchor", name: "Anchor" },
      { id: "tent-lighting", name: "Tent & Lighting" },
      { id: "photography", name: "Photography" },
      { id: "videography", name: "Videography" },
      { id: "makeup", name: "Makeup Artist" },
      { id: "ring-ceremony", name: "Ring Ceremony Setup" },
      { id: "entertainment", name: "Entertainment" },
    ],
  },
  {
    id: "corporate",
    name: "Corporate Event",
    services: [
      { id: "venue", name: "Venue" },
      { id: "catering", name: "Catering" },
      { id: "stage", name: "Stage Setup" },
      { id: "tent-lighting", name: "Tent & Lighting" },
      { id: "dj", name: "DJ" },
      { id: "anchor", name: "Anchor" },
      { id: "sound-system", name: "Sound System" },
      { id: "led-projector", name: "Projector & LED" },
      { id: "photography", name: "Photography" },
      { id: "videography", name: "Videography" },
      { id: "branding", name: "Corporate Branding" },
      { id: "event-staff", name: "Event Staff" },
      { id: "entertainment", name: "Entertainment" },
      { id: "transportation", name: "Transportation" },
    ],
  },
  {
    id: "baby-shower",
    name: "Baby Shower",
    services: [
      { id: "venue", name: "Venue" },
      { id: "home", name: "Home" },
      { id: "decoration", name: "Decoration" },
      { id: "catering", name: "Catering" },
      { id: "cake", name: "Cake" },
      { id: "dj", name: "DJ" },
      { id: "anchor", name: "Anchor" },
      { id: "photography", name: "Photography" },
      { id: "tent-lighting", name: "Tent & Lighting" },
      { id: "games", name: "Games & Activities" },
      { id: "return-gifts", name: "Return Gifts" },
      { id: "theme", name: "Baby Shower Theme" },
    ],
  },
  {
    id: "surprise",
    name: "Surprise Planner",
    services: [
      { id: "home", name: "Home" },
      { id: "hotel-room", name: "Hotel Room" },
      { id: "venue", name: "Venue" },
      { id: "decoration", name: "Decoration" },
      { id: "cake", name: "Cake" },
      { id: "flowers", name: "Flowers" },
      { id: "gift", name: "Gift Arrangement" },
      { id: "candle-light", name: "Candle Light Setup" },
      { id: "photography", name: "Photography" },
      { id: "videography", name: "Videography" },
      { id: "dj", name: "DJ" },
      { id: "live-music", name: "Live Music" },
      { id: "special-entry", name: "Special Entry" },
    ],
  },
];

export const getCategoryByName = (name) =>
  eventCategories.find(
    (category) => category.name.toLowerCase() === String(name || "").toLowerCase()
  );

// ===============================
// LEAD STATUS (mirrors backend enum)
// ===============================

export const LEAD_STATUSES = [
  { value: "fresh", label: "Fresh", color: "#2563eb", bg: "#eff6ff" },
  { value: "seen", label: "Seen", color: "#7c3aed", bg: "#f5f3ff" },
  { value: "call", label: "Call", color: "#0891b2", bg: "#ecfeff" },
  { value: "pending", label: "Pending", color: "#d97706", bg: "#fffbeb" },
  { value: "tokenfound", label: "Token Received", color: "#db2777", bg: "#fdf2f8" },
  { value: "confirmed", label: "Confirmed", color: "#16a34a", bg: "#f0fdf4" },
  { value: "closed", label: "Closed", color: "#64748b", bg: "#f1f5f9" },
];

const FALLBACK_STATUS = { value: "", label: "Unknown", color: "#64748b", bg: "#f1f5f9" };

export const getStatusMeta = (status) =>
  LEAD_STATUSES.find((item) => item.value === status) || { ...FALLBACK_STATUS, label: status || "Unknown" };

// ===============================
// HELPERS
// ===============================

export const formatDate = (dateString) => {
  if (!dateString) return "—";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

export const formatTime = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });
};

export const todayInputValue = () => {
  const now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  return now.toISOString().slice(0, 10);
};

export const isPastDate = (dateString) => {
  if (!dateString) return false;
  const date = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
};

export const isToday = (dateString) => {
  if (!dateString) return false;
  return new Date(dateString).toDateString() === new Date().toDateString();
};

/** Normalises an Indian mobile number into international format (e.g. 919876543210). */
export const toInternationalPhone = (phone) => {
  const digits = String(phone || "").replace(/\D/g, "");
  if (digits.length === 10) return `91${digits}`
  // if (digits.length === 11 && digits.startsWith("0")) return `91${digits.slice(1)}`;
  return digits;
};

export const getWhatsAppUrl = (phone, name) => {
  const number = toInternationalPhone(phone);
  if (!number) return "";
  // const greeting = `Hi${name ? ` ${name}` : ""}, greetings from EventDekho! `;
  // return `https://wa.me/${number}?text=${encodeURIComponent(greeting)}`;
  return `https://wa.me/${number}`;
};

export const getInitials = (name) =>
  String(name || "?")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || "?";
